if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
        this.parentElement.addEventListener("shopify:section:select", () => this.open());
        this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains("is--open")) {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden");
      }

      this.querySelector(".button--close").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.querySelector(
        ".quick-cart-drawer__backdrop"
      ).addEventListener("click", this.close.bind(this));

      this.querySelector(".quick-cart-drawer__blocks").addEventListener("keydown", e => {
        if (e.key === "Escape" && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement =
            focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === "Tab";

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document
          .querySelectorAll(".quick-cart-drawer__trigger")
          .forEach(element => {
            if (!element._init) { // Daha önce eklenmiş mi kontrol edin
              element.addEventListener("click", event => {
                this.fetchProductForQuickCartDrawer(event);
              });
              element._init = true; // Eklenmiş olarak işaretleyin
            }
          });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      /** stop autoplay on quick cart trigger */
      if (event.target.closest("card-product-slider")) {
        event.target
          .closest("card-product-slider")
          .slider.autoplay.stop();
        event.target
          .closest("card-product-slider")
          .classList.add("product--open-on-quick-cart");
      }

      const isRecommendations = event.target.classList.contains(
        "quick-cart-drawer__trigger--recommendations"
      );

      const productCard = event.target.closest("product-card");
      let productOptions = null;

      if (!isRecommendations) {
        if (!productCard) return;
        // get all checked options
        productOptions = productCard.querySelectorAll(
          'input[type="radio"]:checked, select'
        );
      }

      const trigger = event.target.closest("[data-product-url]");
      trigger.classList.toggle("is--loading");
      try {
        const productCardResponse = await fetch(
          `${trigger.dataset.productUrl}/?view=quick-cart`
        );
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const productCard = document.createElement("DIV");
        productCard.insertAdjacentHTML("beforeend", productCardHTML);
        if (!productCard.querySelector(".quick-cart-product")) return;
        this.querySelector(".quick-cart-drawer__main").innerHTML = "";
        this.querySelector(".quick-cart-drawer__main").append(
          productCard.querySelector(".quick-cart-product")
        );

        this.sliderInstance = new Swiper(".quick-cart-drawer__media-swiper", {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: {
            enabled: true
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            }
          }
        });
      } catch (error) {
        // console.log(error);
      } finally {
        trigger.classList.toggle("is--loading");

        if (!isRecommendations) {
          // update quick cart drawer options with product options
          productOptions.forEach(productOption => {
            // console.log(productOption);
            const quickCartDrawerOption = this.querySelector(
              `[name="${productOption.name}"][value="${productOption.value}"]`
            );
            const quickCartDrawerOptionLabel = quickCartDrawerOption.parentElement.parentElement.querySelector('legend');
            const quickCartDrawerOptionLabelInnerHTML =
              quickCartDrawerOptionLabel.innerHTML;

            // before updating radio button state, remove checked attribute for specific name
            this.querySelectorAll(
              `[name="${productOption.name}"]`
            ).forEach(radioInput => {
              radioInput.removeAttribute("checked");
              radioInput.closest("li").classList.remove("checked");
            });

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute("checked", "");
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = productOption.value;
              }
            }

            // update variant id in product card with selected variant id
            this.querySelector("product-card").querySelector(
              'input[name="id"]'
            ).value = productCard.querySelector(
              'input[name="id"]'
            ).value;

            // update radio button state
            if (quickCartDrawerOption) {
              quickCartDrawerOption
                .closest("li")
                .classList.add("checked");
            }

            // initilise for disabled states to be checked and updated
            this.querySelector("product-card").init();
          });
        }

        // short wait before opening drawer
        setTimeout(() => {
          this.open();
        }, 500);

        // add small delay to open drawer
        // this.open();

        let variantSizeCard
        let variantProductIdCard
        let currentVariantCard = null
        let variantColorCard


        // update label when variant is selected
        this.querySelector(".quick-cart-drawer__main")
          .querySelectorAll(".variant-option-radio-input")
          .forEach(radioInput => {
            radioInput.addEventListener("click", event => {
              const quickCartDrawerOptionLabel = event.target.parentElement.parentElement.querySelector('legend');
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.value;
              }
              $('.color_input').prop('disabled',false)
              variantSizeCard = event.target.value;
              mp_update_sizesCard();
              mp_select_variantCard();

              // update variant id in product card with selected variant id
              /* const selectedVariantId = this.querySelector(
                ".product-card__add-to-cart--form input[name='id']"
              ).value;

              // get product variants data
              const productVariantsData = this.querySelector("product-card").variantsObj;
              const featuredMedia = productVariantsData.find(
                variant => variant.id == selectedVariantId
              )?.featured_media;

              if (featuredMedia) {
                this.setActiveMedia(featuredMedia.id);
              } */
            });
          });
          
        this.querySelector(".quick-cart-drawer__main")
          .querySelectorAll(".color-option-label")
          .forEach(radioInput => {
            radioInput.addEventListener("click", event => {
              const quickCartDrawerOptionLabel = event.target.parentElement.parentElement.querySelector('legend');
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.title;
              }
              $('.color_input').prop('disabled',false)
              $(".quick-cart-drawer__main .color-option-label").removeClass('selected_Input')
              event.target.classList.add('selected_Input')
              console.log(event.target.getAttribute('secondproduct'))
              variantProductIdCard = event.target.getAttribute('secondproduct');
              mp_update_sizesCard();
              mp_select_variantCard();
            });
          });

          

          
          function mp_update_sizesCard(){
            var variantsInfo = JSON.parse(document.getElementById('variants_data_card').textContent);
            let sizes = []
            for(const variant of variantsInfo){
                if(variant.product == variantProductIdCard){
                    if(variant.available){
                        sizes.push(variant.options[0])
                    }
                }
            }
            let available = true
            $('quick-cart-drawer fieldset:first input').each(function(){
                if(sizes.includes($(this).val())){
                    $(this).removeClass('disabled')
                    $(this).prop('disabled', false);
                }
                else{
                    $(this).addClass('disabled')
                    $(this).prop('disabled', true);
                    if(variantSizeCard == $(this).val()){
                        available = false
                    }
                }
            })
            if(!available){
                //$('*[val="'+variantSize+'"].pills-variant-labels').removeClass('round-border')
                $('quick-cart-drawer .button--filled').prop('disabled', true);
                $('quick-cart-drawer .button--filled').text('Agotado')
                currentVariantCard = null
            }
            else{
                //$('*[val="'+variantSize+'"].pills-variant-labels').addClass('round-border')
                $('quick-cart-drawer .button--filled').prop('disabled', false);
                $('quick-cart-drawer .button--filled').text('Agregar a mi bolsa')
            }
          }

          
          function mp_select_variantCard(){
            var variantsInfo = JSON.parse(document.getElementById('variants_data_card').textContent);
            for(const variant of variantsInfo){
                if(variant.options.includes(variantSizeCard) && variant.product == variantProductIdCard){
                    if(variant.available){
                        currentVariantCard = variant.id
                        variantColorCard = variant.color
                    }
                    mp_show_imagesCard(variant.color)
                    $('quick-cart-drawer input[name="id"]').val(variant.id);
                    var price = variant.price
                    console.log('no compare ',variant.compare_at_price)
                    if(variant.compare_at_price){
                        const priceContainer = $('quick-cart-drawer .price__container');
                        const priceChild = priceContainer.children().first();
                        priceChild.html(`
                            <div class="price__sale-inner">
                                <span class="visually-hidden">Precio de rebaja</span>
                                <s>${variant.compare_at_price}</s>
                                <ins>
                                    <span class="visually-hidden">Precio regular</span>
                                    ${variant.price}
                                </ins>
                            </div>
                        `);
                        showDiscountBadgeCard(parseFloat(variant.price.replace(/[^0-9.]/g, '')), parseFloat(variant.compare_at_price.replace(/[^0-9.]/g, '')))
                    }
                    else{
                        const priceContainer = $('quick-cart-drawer .price__container');
                        const priceChild = priceContainer.children().first();
                        priceChild.html(`
                            <span class="visually-hidden">Precio regular</span>
                            ${variant.price}
                        `);
                        const discountBadge = document.querySelector("quick-cart-drawer .product-card__badge--discount");
                        if (discountBadge){
                            discountBadge.classList.add("hiddenElement");
                            discountBadge.classList.remove("noHiddenElement");
                        }
                    }
                }
            }
          }


          function mp_show_imagesCard(color){
            color = color.replaceAll(' ', '-')
            console.log(color)
            $('quick-cart-drawer .swiper-slide').each(function(){
              if($(this).attr('color') != color){
                $(this).css('display','none')
              }
              else{
                $(this).css('display','block')
              }
            })
          }


          function showDiscountBadgeCard(price, compare_at_price) {
            const discountBadge = document.querySelector("quick-cart-drawer .product-card__badge--discount");
            if (!discountBadge) return;


            if (compare_at_price > price) {
              discountBadge.classList.remove("hiddenElement");
              discountBadge.classList.add("noHiddenElement");
              const percentageElement = discountBadge.querySelector(".percentage");
              // calculate discount percentage
              const discountPercentage = Math.round(
                ((compare_at_price - price) / compare_at_price) * 100
              );
              // update discount percentage
              percentageElement.textContent = discountPercentage;
            } else {
              discountBadge.classList.add("hiddenElement");
              discountBadge.classList.remove("noHiddenElement");
            }
          }

          
        $('quick-cart-drawer .selected_Input').click()
        $('quick-cart-drawer .variant-option-radio-input[checked]').click()


          
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(
        this.querySelectorAll("[data-media-id]")
      ).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      const quickCartDrawer = document.querySelector(".quick-cart-drawer__blocks");
      const closeButton = quickCartDrawer.querySelector(".button--close");
      quickCartDrawer.setAttribute("tabindex", "0");
      closeButton.setAttribute("tabindex", "0");
      this.classList.add("is--open");
      this.opened();

      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
      $('.color_input').prop('disabled',false)
    }

    close() {
      this.toggleState = false;
      document
        .querySelector("body")
        .classList.remove("overflow-hidden");
      this.classList.remove("is--open");
      this.closed();
      this.toggleAriaExpanded();

      /** start autoplay on quick cart drawe close */
      if (document.querySelector("card-product-slider.product--open-on-quick-cart")) {
        document.querySelector("card-product-slider.product--open-on-quick-cart").slider.autoplay.start();
        document.querySelector("card-product-slider.product--open-on-quick-cart").classList.remove("product--open-on-quick-cart");
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target
            .closest("button")
            .setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute(
          "aria-expanded",
          true
        );
      } else {
        document
          .querySelectorAll('[aria-controls="quick-cart-drawer"]')
          .forEach(button => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

    opened() {
      const openedEvent = new Event("opened", { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event("closed", { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define("quick-cart-drawer", QuickCartDrawer);
}
